export default "__VITE_ASSET__Cz03Hy5e__"